<template>
  <v-dialog
    v-model="dialog"
    max-width="1000px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Adjusted Amount History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="entitlement.assignable.person ? entitlement.assignable.person.name : entitlement.assignable.name"
      :text="entitlement.claim_type.name"
      class="mb-0"
      max-height="600px"
    > 
      <template v-if="!loading">
        <v-container>
          <v-data-table
            :headers="headers"
            :items="claimEntitlementAdjustments"
            item-value="id"
            fixed-header
            class="overflow"
          >
            <template v-slot:item.created_at="{ item }">
              {{ $moment(item.created_at).format('YYYY-MM-DD') }}
            </template>
            <template v-slot:item.adjusted_amount="{ item }">
              {{ currencyFormatting(item.adjusted_amount) }}
            </template>
            <template v-slot:item.remark="{ item }">
              <div v-html="item.remark" />
            </template>
          </v-data-table>
        </v-container>
      </template>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      entitlement: {
        type: Object,
        default: null,
      },    
    },
    data () {
      return {
        dialog: false,
        loading: false,
        claimEntitlementAdjustments: [],
        headers: [
          {
            text: 'Date',
            align: 'left',
            value: 'created_at',
            width: '15%',
          },
          {
            text: 'Adjusted Amount (RM)',
            align: 'right',
            value: 'adjusted_amount',
            width: '30%',
          },
          {
            text: 'Remark',
            align: 'left',
            value: 'remark',
            width: '55%',
          },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.claimEntitlementAdjustments = this.entitlement.claim_entitlement_adjustments
        }
      },
    },
    methods: {
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    max-height:460px;
    overflow: auto;
  }
</style>
